import { FC } from "react"
import { RouteComponentProps } from '@reach/router';
import { RootState } from 'reducers';
import { connect } from 'react-redux';
import { Form} from "antd";
import { createEntity, getEntity, reset, updateEntity } from "./returnGoods.reducer";
import EditPage, { EditStateAndDispatchProps } from "layouts/page-wraper/edit-page-modal";
import { ReturnGoods } from "model/product/returnGoods.model";
export interface ReturnGoodsEditProps extends EditStateAndDispatchProps<ReturnGoods>, StateProps, DispatchProps, RouteComponentProps {
}

const ReturnGoodsEdit: FC<ReturnGoodsEditProps> = props => {
  const [form] = Form.useForm();
  return (
    <EditPage<ReturnGoods>
      title="编辑"
      form={form}
      {...props}
    >
    </EditPage>);
};

const mapStateToProps = ({ returnGoods }: RootState) => ({
  entity: returnGoods.entity,
  updateSuccess: returnGoods.updateSuccess,
  updating: returnGoods.updating,
  createSuccess: returnGoods.createSuccess
});

const mapDispatchToProps = {
  getEntity,
  createEntity,
  updateEntity,
  reset,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(ReturnGoodsEdit);
